<template>
	<div class="containerMain">
		<title-bar :topTitle="true" topTitleText="Incidencias"/>
		<title-bar v-if="school" :title="school.name"/>
		<div class="col inner" v-if="school && history && history.length > 0">
			<div class="col between innerRubric sd">
				<b-table responsive style="cursor: pointer;" class="category all" striped hover :items="history" :fields="tableFields" @row-clicked="onRowClick">
					<template slot="date" slot-scope="item">
						{{item.value ? getHumanDate(item.value) : ''}}
					</template>
					<template slot="resolveBy" slot-scope="item">
						{{item.value ? getHumanDate(item.value) : 'Sin fecha'}}
					</template>
					<template slot="title" slot-scope="item">
						{{item.value || 'Sin título'}}
					</template>
					<template slot="status" slot-scope="row">
						<status-badge :status="row.value"/>
					</template>
					<template slot="issuePriority" slot-scope="row">
						<b-badge :variant="getPriorityColor(row.value.id)">{{row.value.name}}</b-badge>
					</template>
				</b-table>
			</div>
		</div>
		<div class="col inner" v-else>
			<spinner :isMiniSpinner="true"/>
		</div>
	</div>
</template>

<script>
import helpers from '@/helpers';
import mediator from '@/mediator';

export default {
	props: ['schoolId'],
	mounted () {
		setTimeout(() => {
			mediator.showContent();
		}, 1000);
	},
	data () {
		return {
			tableFields: {
				date: {
					label: 'Fecha',
					sortable: true
				},
				title: {
					label: 'Título/Nombre',
					sortable: true
				},
				resolveBy: {
					label: 'Fecha para resolver',
					sortable: true
				},
				personName: {
					label: 'Coach',
					sortable: true
				},
				issuePriority: {
					label: 'Prioridad',
					sortable: true
				},
				status: {
					label: 'Estado',
					sortable: true
				}
			}
		};
	},
	computed: {
		school () {
			if (!this.$store.state.admin.schools) return null;
			return this.$store.state.admin.schools.find((school) => (school.schoolId == this.schoolId));
		},
		history () {
			if (!this.$store.state.admin.schoolHistory) return null;
			return this.$store.state.admin.schoolHistory.map((history) => {
				history.personName = history.personCreated ? this.getPersonFullName(history.personCreated) : '';
				history.date = history.createdAt;
				history.status = history.statuses[0];
				return history;
			});
		}
	},
	methods: {
		getHumanDate (date) {
			return helpers.dateTime.getHumanDate(date);
		},
		getHumanDateAndTime (date) {
			return helpers.dateTime.getHumanDateAndTime(date);
		},
		getPersonFullName (person) {
			return helpers.persons.getPersonFullName(person);
		},
		onRowClick (item) {
			this.$router.push(`/coaching/admin/schools/${this.schoolId}/issue/${item.id}`);
		},
		getPriorityColor (priorityId) {
			if (priorityId == '1') return 'danger';
			if (priorityId == '2') return 'warning';
			if (priorityId == '4') return 'success';
			if (priorityId == '3') return 'primary';
		}
	}
};
</script>



// WEBPACK FOOTER //
// src/components/routes/admin/SchoolIssues.vue